import { cacheDom } from "../utils/QuerySelectors.js"

const dom = {}
const qs = {
  
}
const qsAll = {
  targets: 'data-link-target',  
}

export const setupLinkButtons = () => {
  cacheDom(dom, qs, qsAll)
  
  dom.targets.forEach(target => {
    target.addEventListener('click', () => {
      const id = target.dataset.linkTarget
      const element = document.querySelector(`#${id}`)
      const siblings = target.parentNode.querySelectorAll(`[${qsAll.targets}]`)
      siblings.forEach(sibling => {
        sibling.classList.toggle('button--primary__filled', sibling == target)
        sibling.classList.toggle('button--primary', sibling != target)
      })
      if(element) {
        window.scrollTo({
          left: 0, 
          top: element.offsetTop - 120, 
          behavior: "smooth",
        })
      }
    })
  })
}